import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const get_star_gift_templates = createAsyncThunk(
  'StarGift/get_star_gift_templates',
  async (p: any, store: any) => {
    const {h_m} = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/gift/get_star_gift_templates',
      {h_m},
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data || []
  }
)

const initialState: {
  templateList: Array<any>
} = {
  templateList: [],
}

export function useStarGift() {
  return useSelector((store) => store.Animal_Chipmunk)
}

export const StarGiftSlice = createSlice({
  name: 'StarGift',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_star_gift_templates.fulfilled, (state, action) => {
      Object.assign(state.templateList, action.payload)
    })
  },
})

export default StarGiftSlice.reducer
export const StarGiftActions = StarGiftSlice.actions
